module.exports = __webpack_public_path__ + "static/media/external-link-hover.73f16cba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-hover.svg
// module id = 534
// module chunks = 0